import { render } from "./JsonView.vue?vue&type=template&id=0844365a&scoped=true"
import script from "./JsonView.vue?vue&type=script&lang=js"
export * from "./JsonView.vue?vue&type=script&lang=js"

import "./JsonView.vue?vue&type=style&index=0&id=0844365a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0844365a"]])

export default __exports__